import axios from 'axios';
import { TOPICS_WIDGET_DATA_KEY, TOPICS_WIDGET_PREVIOUS_DATA_KEY } from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {
    DATA_KEY: () => TOPICS_WIDGET_DATA_KEY,
    PREVIOUS_DATA_KEY: () => TOPICS_WIDGET_PREVIOUS_DATA_KEY
};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, topicGroupId, properties, timeZone, limit } = {}) {
        const params = {
            limit,
            range,
            timeZone,
            accountId,
            topicGroupId,
            sort: 'true',
            kind: 'status',
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/topics', { params, encodeURI: true });
    },

    csv(vuexContext, { range, accountId, topicGroupId, properties, timeZone, limit } = {}) {
        const params = {
            limit,
            range,
            timeZone,
            accountId,
            topicGroupId,
            sort: 'true',
            kind: 'status',
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePostWithHeaders('/v1/dashboard/topics.csv', { params, encodeURI: true });
    }
};
